import CbInstanceOptions from '@/interfaces/cb-instance-options';

export enum LogDataType {
  ERROR = 'ERROR',
  INFO = 'INFO',
}

export type Metadata = {
  custom_domain?: string;
  domain?: string;
  site?: string;
  host_name?: string;
  site_meta?: any;
  options?: CbInstanceOptions;
  window_url?: string;
};
